import * as React from 'react';
export const bimpliSvg = React.forwardRef(function bimpliSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0086F7',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.533 8.28a1.564 1.564 0 1 1-3.127-.001 1.564 1.564 0 0 1 3.127 0Zm.717 13.649c.036 0 .065.03.064.065a5.57 5.57 0 0 1-11.14 0 .063.063 0 0 1 .064-.065h3.01c.035 0 .064.03.065.065a2.431 2.431 0 0 0 4.861 0 .067.067 0 0 1 .067-.065h3.009ZM14.082 7.237A2.802 2.802 0 0 0 11.28 4.5H9.066A.065.065 0 0 0 9 4.565v2.672c0 .036.03.065.065.065h1.89v7.95h.002a4.893 4.893 0 0 0-.002.162v.004a4.79 4.79 0 0 0 9.578.028v-1.563a.065.065 0 0 0-.065-.065h-2.932a.065.065 0 0 0-.066.065v1.629a1.694 1.694 0 1 1-3.388 0V7.237Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M32 13 19 0h13v13Z',
      fill: '#FFD800',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.555 2.005a1.64 1.64 0 0 1 .259 0l.082.006c.125.008.25.017.372.042.17.036.334.098.487.188.149.088.284.19.385.328.055.075.095.165.127.253.085.229.084.47.083.71v.006c-.002.42-.002.838-.002 1.257v.508c0 .095.005.098.102.098h.186l.3-.002c.047 0 .065.017.064.063l-.001.272v.138c0 .059-.013.07-.07.069h-1.107c-.049 0-.069-.017-.068-.065.001-.112.002-.223 0-.335a.132.132 0 0 0-.009-.04l-.006-.019a.222.222 0 0 1-.01.003l-.024.007a.113.113 0 0 0-.033.014l-.118.086a1.752 1.752 0 0 1-.239.161c-.115.06-.24.103-.365.144l-.068.023a1.663 1.663 0 0 1-.194.05l-.06.013a.555.555 0 0 1-.102.013h-.097c-.038 0-.075 0-.113.002a1.517 1.517 0 0 1-.67-.13 1.031 1.031 0 0 1-.57-.575l-.008-.02a1.622 1.622 0 0 1-.026-.063A1.027 1.027 0 0 1 26 4.86c0-.139.037-.268.096-.39.083-.171.205-.312.36-.418a2.04 2.04 0 0 1 .273-.148l.014-.007c.238-.114.492-.144.753-.15a4.49 4.49 0 0 1 .874.08c.088.015.174.042.26.068.071.022.093.008.093-.066-.002-.18-.002-.36-.002-.54a.645.645 0 0 0-.074-.282l-.004-.009a.546.546 0 0 0-.089-.145.776.776 0 0 0-.204-.17 1.525 1.525 0 0 0-.896-.141 1.1 1.1 0 0 0-.353.107c-.054.027-.067.056-.049.113a1.013 1.013 0 0 0 .024.072c.056.178-.102.434-.305.464-.155.024-.295.015-.41-.101a.341.341 0 0 1-.112-.246c0-.016 0-.033-.002-.05-.002-.038-.004-.076.006-.11a.976.976 0 0 1 .098-.24.886.886 0 0 1 .43-.348c.134-.057.271-.112.412-.149a1.98 1.98 0 0 1 .327-.046c.012 0 .023-.002.035-.003Zm.408 2.158a4.443 4.443 0 0 0-.502-.01 1.125 1.125 0 0 0-.46.099c-.162.068-.267.21-.345.373-.041.1-.046.358.002.459a.73.73 0 0 0 .353.355c.12.04.455.103.829.044l.068-.021a1.543 1.543 0 0 0 .367-.154c.066-.039.13-.083.192-.127l.052-.036.024-.016a1.46 1.46 0 0 0 .14-.105.126.126 0 0 0 .044-.08c.003-.167.002-.333.002-.5v-.083c0-.049-.027-.074-.076-.081l-.177-.03-.101-.019a6.57 6.57 0 0 1-.122-.023 2.708 2.708 0 0 0-.29-.045Z',
      fill: '#060500',
    }),
  );
});
bimpliSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bimpli = {
  category: 'brand',
  colorable: false,
  name: 'bimpli',
  svg: bimpliSvg,
};
